var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile---Liderzy---Upload",
    transform: "translate(-20.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(20.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    fillRule: "nonzero",
    stroke: "#024766"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0.5 C11.9812609,0.5 14.2311363,1.50958001 15.8607781,3.13922187 C17.49042,4.76886373 18.5,7.01873913 18.5,9.5 C18.5,11.9812609 17.49042,14.2311363 15.8607781,15.8607781 C14.2311363,17.49042 11.9812609,18.5 9.5,18.5 C7.01873913,18.5 4.76886373,17.49042 3.13922187,15.8607781 C1.50958001,14.2311363 0.5,11.9812609 0.5,9.5 C0.5,7.01873913 1.50958001,4.76886373 3.13922187,3.13922187 C4.76886373,1.50958001 7.01873913,0.5 9.5,0.5 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,5 C9.77614237,5 10,5.22385763 10,5.5 L10,8.999 L13.5,9 C13.7761424,9 14,9.22385763 14,9.5 C14,9.77614237 13.7761424,10 13.5,10 L10,10 L10,13.5 C10,13.7761424 9.77614237,14 9.5,14 C9.22385763,14 9,13.7761424 9,13.5 L9,10 L5.5,10 C5.22385763,10 5,9.77614237 5,9.5 C5,9.22385763 5.22385763,9 5.5,9 L9,9 L9,5.5 C9,5.22385763 9.22385763,5 9.5,5 Z",
    id: "Combined-Shape",
    fill: "#024766"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInCircle);
export default __webpack_public_path__ + "static/media/addInCircle.d55f0f9596ff246e7008f25b72f399fe.svg";
export { ForwardRef as ReactComponent };